import React from "react";
import { Dropdown } from "react-bootstrap";

function SingleSelectDropdown({ samples, selectedSample, handleSampleChange, type }) {
    return (
        <Dropdown className="d-inline-block">
            <Dropdown.Toggle className="p-0" id="singleSelectDropdown">
                { 
                      type === "from"
                    ? "From"
                    : type === "bcc"
                    ? "BCC"
                    : "from"}
            </Dropdown.Toggle>

            <Dropdown.Menu  className="el-admin"  renderOnMount={true} 
                popperConfig={{
                    strategy: "fixed"
                }}>
                {samples.map((sample) => (
                    <Dropdown.Item
                        key={sample.id}
                        active={selectedSample === sample.id}
                        onClick={() => 
                        { 
                            handleSampleChange(sample.id)}
                        }
                    >
                        {sample.label}
                    </Dropdown.Item>
                ))}
                {/* <Dropdown.Divider />
                <Dropdown.Item  className="btn btn-link" onClick={() => handleSampleChange("")}>Clear Selection</Dropdown.Item> */}
                    <div>
                    <input
                        type="button" value="Clear"
                        className="btn btn-link"
                        onClick={() => handleSampleChange("")}
                    />
                </div>
            </Dropdown.Menu>
        </Dropdown>
    );
}

export default SingleSelectDropdown;
